interface CrcCheckboxCheckProps {
  strokeColor?: string;
}

const CHECKBOX_SIZE_PX = 14;

/**
 * Figma checkbox check glyph drawn inside the 14×14 control box.
 * Outer frame is the 14×14 viewBox; the path is the inner check leaf from node 555:9811.
 *
 * @param props - Optional stroke color for the check
 * @param props.strokeColor - Check mark color (defaults to white)
 * @returns Check-mark path sized to the checkbox viewBox
 */
const CrcCheckboxCheck = ({ strokeColor = "#FFFFFF" }: CrcCheckboxCheckProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={CHECKBOX_SIZE_PX}
      height={CHECKBOX_SIZE_PX}
      viewBox="0 0 14 14"
      fill="none"
      aria-hidden
      className="block h-[14px] w-[14px]"
    >
      <path
        d="M2 7.00008L5.33333 10.3334L12 3.66675"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CrcCheckboxCheck;
